// extracted by mini-css-extract-plugin
export default {"main":"main__headerMobile___dhhF5D3Sf6"};